import { initAppTranslations } from 'I18n/init/setup/AppInit';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import registerBasicData from 'I18n/init/register/sync/registerBasicData';
import lang from 'i2l?mode=very-lazy&query=sporks!../../lang/en.lyaml';
export async function startI18n({
  locale,
  langEnabled,
  timezone
}) {
  const I18nProvider = createStandardI18nProvider();
  I18nProvider.setLocale({
    locale,
    langEnabled,
    timezone
  });
  await initAppTranslations([I18nProvider.register(lang), registerBasicData(I18nProvider)]);
  return I18nProvider;
}